

import { RequestAllDetails } from "../models/requestAllDetails";
import { RequestLetter } from '../models/requestLetter';

export interface IRequestDetailService {
    getDetail(trackingId: number, isRoleValidationRequired: boolean): Promise<RequestAllDetails>;
    
    downloadAttachmentByAttachmentId(attachmentId): Promise<any>;
    generateRequestLetterByTrackingId(trackingId: number): Promise<any>;
    processEmailRequestByTrackingId(trackingId : number) : Promise<any>;

   }

export class RequestDetailService implements IRequestDetailService {
    static $inject = ['$http'];

    constructor(private _$http: angular.IHttpService) {
    }

    getDetail(trackingId: number, isRoleValidationRequired: boolean): Promise<RequestAllDetails> {
     return new Promise<any>((resolve, reject) => {
         this._$http.get<RequestAllDetails>(`/Request/detail/${trackingId}?isRoleValidationRequired=${isRoleValidationRequired}`)
             .then((response) => {
                 const detail = new RequestAllDetails(response.data);
                 resolve(detail);
             });
        });
    }

    generateRequestLetterByTrackingId(trackingId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this._$http.post(`/Request/GenerateByTrackingId/${trackingId}`, { trackingId },
                { responseType: 'arraybuffer', headers: { 'Accept': 'application/pdf, */*' } })
                .then(
                    (response: any) => {
                        resolve(response.data);
                })
                .catch(
                    (response: any) => {
                        reject(response);
                        console.log(response);
                });
        });

    }

    downloadAttachmentByAttachmentId(attachmentId): Promise<any> {


        return new Promise<any>((resolve, reject) => {
            this._$http.post(`/Request/DownloadAttachment/${attachmentId}`,
                attachmentId,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Accept':
                            'application/pdf,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, image/jpeg,image/gif */*'
                    }
                })
                .then(
                    (response: any) => {
                        resolve(response.data);
                    })
                .catch(
                    (response: any) => {
                        reject(response);
                    });
        });

    }

    processEmailRequestByTrackingId(trackingId: number): Promise <any> {
            return new Promise<any>((resolve, reject) => {
                this._$http.post(`/Request/SendEmailNotification/${trackingId}`, trackingId)
                    .then(
                        (response: any) => {
                            resolve(response.data);
                        })
                    .catch(
                        (response: any) => {
                            reject(response);
                        });
            });

        }
}

angular.module('deliveryCreate.app').service("requestDetailService", RequestDetailService);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/services/requestDetailService.ts
 **/